import { Title } from '@mantine/core';
import './styles.scss';

export interface HeaderProps {
  pageTitle?: string;
}

const Header = ({ pageTitle }: HeaderProps) => {
  return (
    <>
      <Title order={1} className="header">
        {pageTitle}
      </Title>
    </>
  );
};

export default Header;
